import MobileDetect from 'mobile-detect'
import _ from 'lodash'

const MobileDetectPlugin = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          device: new MobileDetect(window.navigator.userAgent)
        }
      },
      computed: {
        isMobile() {
          return !_.isEmpty(this.device.phone())
        },
      },
    })
  }
}

export default MobileDetectPlugin
